import { TrackingDescriptionIDType } from 'defs/tracking';
import axios, { AxiosResponse } from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';
import { TrackingDescriptionImageWrapperDtoType } from 'types/services/magnolia/dtos/TrackingDescriptionImageWrapperDto';

export type TrackingDescriptionResponseType = {
	type: TrackingDescriptionIDType;
	headLine: string;
	images: TrackingDescriptionImageWrapperDtoType[];
};

export type ResponseTrackingDescriptionType = TrackingDescriptionResponseType[];

export const fetchTrackingDescriptions = (): Promise<AxiosResponse<ResponseTrackingDescriptionType>> => {
	const requestUrl = `${appConfig.env.urlMagnoliaAPICoach}/trackingdescriptions`;
	return axios.get(requestUrl, { withCredentials: false });
};
